import axios from "axios";
import { Message } from "element-ui";

// API基础地址
export const BASE_URL = 'https://order.huitongxin.cn'
// export const BASE_URL = "http://127.0.0.1:8081";

// 创建axios实例
const service = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

// 检查参数中是否包含undefined
const hasUndefinedParams = (params) => {
  if (!params || params === undefined) return false;

  const checkValue = (value) => {
    // 检查 JavaScript 的 undefined
    if (value === undefined) {
      return true;
    }
    if (Array.isArray(value)) {
      return value.some((item) => checkValue(item));
    }
    if (typeof value === "object" && value !== null) {
      return Object.values(value).some((item) => checkValue(item));
    }
    return false;
  };

  if (typeof params === "object") {
    return Object.values(params).some((value) => checkValue(value));
  }

  return params === undefined;
};

// request拦截器
service.interceptors.request.use(
  (config) => {
    // 检查请求参数中是否包含undefined
    const requestParams = {
      ...config.params, // URL查询参数
      ...(config.data && typeof config.data === "object" ? config.data : {}), // 请求体参数
    };

    if (hasUndefinedParams(requestParams)) {
      Message({
        message: "参数错误",
        type: "warning",
        duration: 3 * 1000,
      });
      console.warn("请求被拦截，参数包含undefined:", {
        url: config.url,
        method: config.method,
        params: requestParams,
      });
      // 返回一个被拒绝的Promise，阻止请求发送
      return Promise.reject(new Error("请求参数包含undefined字段"));
    }

    return config;
  },
  (error) => {
    console.error("请求配置错误:", error);
    return Promise.reject(error);
  }
);

// response拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    console.log("响应数据:", response.config.url, res);

    if (response.status === 200) {
      return res;
    } else {
      Message({
        message: res.message || "请求失败",
        type: "error",
        duration: 3 * 1000,
      });
      return Promise.reject(new Error(res.message || "请求失败"));
    }
  },
  (error) => {
    // 如果是参数检查被拦截的错误，不再重复显示消息
    if (error.message === "请求参数包含undefined字段") {
      return Promise.reject(error);
    }

    console.error("响应错误详情:", error);
    console.error("错误配置:", error.config);
    console.error("错误响应:", error.response);

    let message = "网络错误";

    if (error.response) {
      const status = error.response.status;
      console.error("响应状态码:", status);
      console.error("响应数据:", error.response.data);

      switch (status) {
        case 400:
          message = "请求参数错误";
          break;
        case 401:
          message = "未授权访问";
          break;
        case 403:
          message = "禁止访问";
          break;
        case 404:
          message = "接口不存在";
          break;
        case 500:
          message = "服务器内部错误";
          break;
        default:
          message = `服务器错误 ${status}`;
      }
    } else if (error.request) {
      console.error("请求已发出但无响应:", error.request);
      message = "服务器无响应，请检查网络连接";
    } else {
      console.error("请求配置错误:", error.message);
      message = "请求配置错误";
    }

    if (error.message && error.message.includes("CORS")) {
      message = "CORS跨域错误，请联系后端配置";
    }

    Message({
      message,
      type: "error",
      duration: 5 * 1000,
    });

    return Promise.reject(error);
  }
);

export default service;
